import classNames from "classnames/bind";
import styles from "./ShowInfoUser.module.css";
import Button from "../../../components/Button/Button";
import { EditIcon } from "../../../components/Icons/Icons";
import Avatar from "./Avatar";
import InfoUserItem from "./InfoUserItem";
import { useEffect, useState } from "react";
import axiosClient from "../../../services/axiosClient";
import Toast from "../../../components/Toast";
import { formatDB, formatDDMMYY, isValidatorEmail, isValidatorPhone } from "../../../utils";
import { Loading } from "../../../components";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { getAvatarHeader } from "../../../store/Actions";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

function ShowInfoUser() {
    const [isChange, setIsChange] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dateJoined, seDateJoined] = useState('')
    const [editTime, setEditTime] = useState('')
    const [userTypeName, setUserTypeName] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [errorPhone, setErrorPhone] = useState(false)
    const [errorEmail, setErrorEmail] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataUser, setDataUser] = useState({
        address_detail: "Số 43 Hoàng Quốc Việt",
        birthday: "12-10-2002",
        // commune_code: "testCommune",
        // company_code: "testCompany",
        // district_code: "testDistrict",
        email: "test@email.com",
        name: "Hò Văn Tèn",
        nation_code: "VNM",
        phone: "0123456789",
        // province_code: "testProvince",
        // staff_position_code: "testStaffPosition",
        avatar: null,
    })
    const [dataStore, dispatch] = useStoreContext();
    const { t } = useTranslation()


    useEffect(() => {
        const getDefaulData = async () => {
            setIsLoading(true)
            try {
                const res = await axiosClient.get('/user/get-user-info/')
                res.forEach(item => {
                    setDataUser({
                        address_detail: item.ADDRESS_DETAIL,
                        birthday: item.BIRTHDAY ? formatDB(item.BIRTHDAY) : "12-10-2002",
                        email: item.EMAIL,
                        phone: item.PHONE,
                        name: item.NAME,
                        // staff_position_code: "testStaffPosition",
                        // commune_code: "testCommune",
                        // company_code: "testCompany",
                        // district_code: "testDistrict",
                        // province_code: "testProvince",
                        nation_code: "VNM",
                        avatar: item.AVATAR,
                    })
                    seDateJoined(formatDDMMYY(item.DATE_JOINED))
                    setEditTime(item.EDIT_TIME)
                    setUserTypeName(item.USERTYPE_NAME)
                    setCompanyName(item.COMPANY_NAME)
                })
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
            }
        }
        getDefaulData()
    }, [loading])

    const handleValueChange = (data, name) => {
        if (!isChange) {
            setIsChange(true)
        }
        if (name === 'USERNAME') {
            setDataUser(prev => ({ ...prev, name: data }))
        } else if (name === 'EMAIL') {
            setDataUser(prev => ({ ...prev, email: data }))
            setErrorEmail(false)
        } else if (name === 'PHONE') {
            setDataUser(prev => ({ ...prev, phone: data }))
            setErrorPhone(false)
        }
    }

    const handleSave = async () => {
        try {
            const res = await axiosClient.put('/user/put-change-user-info/', dataUser)
            setIsChange(false)
            dispatch(getAvatarHeader(!dataStore.reGetAvatarHeader))
            window.location.reload()
            Toast.open("Thay đổi thông tin thành công", 'success')
        } catch (error) {
            // console.log(error);
            Toast.open("Thay đổi thông tin không thành công", 'danger')
        }
    }

    const handleCancel = () => {
        setLoading(!loading)
        setIsChange(false)
    }

    return (
        <>
            <div className={cx('content-info')}>
                <div className={cx('body-info')}>
                    <InfoUserItem
                        name={'USERNAME'}
                        label={t("infoUser.userName")}
                        onChange={handleValueChange}
                        value={dataUser.name}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'PHONE'}
                        label={t("infoUser.phoneNumber")}
                        onChange={handleValueChange}
                        value={dataUser.phone}
                        error={errorPhone}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'EMAIL'}
                        label={t("infoUser.email")}
                        onChange={handleValueChange}
                        value={dataUser.email}
                        error={errorEmail}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'DATE_JOINED'}
                        label={t('infoUser.timeCreate')}
                        disabled
                        placeholder={"dd-mm-yyyy"}
                        value={dateJoined}
                        type={'date'}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'EDIT_TIME'}
                        label={t("infoUser.lastEdit")}
                        disabled
                        placeholder={"dd-mm-yyyy"}
                        value={editTime}
                        type={'date'}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'COMPANY_NAME'}
                        label={t("infoUser.company")}
                        disabled
                        value={companyName}
                        style={{
                            width: '298.5px'
                        }}
                    />
                    <InfoUserItem
                        name={'USERTYPE_NAME'}
                        label={t("infoUser.groupUser")}
                        disabled
                        value={userTypeName}
                        style={{
                            width: '298.5px'
                        }}
                    />
                </div>
                {!isLoading ? (<Avatar infoUser={dataUser} />) : <Loading />}
            </div>
            {isChange && <div className={cx('actions')}>
                <Button className={cx('btn-close')} title={'Hủy'} onClick={handleCancel} />
                <Button className={cx('btn-save')} title={'Lưu'} onClick={handleSave} />
            </div>}
        </>
    )
}

export default ShowInfoUser;